import React, { useState, useEffect, useRef } from "react";
import Input from "@hig/input";
import styled from "styled-components";
import PropTypes from "prop-types";
import DataList from "./DataList/DataList";

const TextInput = ({
  state,
  dispatch,
  className,
  placeholder,
  handleChange,
  handleSubmit,
  datalist,
  value,
  focusIn,
  handleValidation,
  // eslint-disable-next-line no-unused-vars
  isError,
  id,
  // adding for automation locators.
  autoComplete
}) => {
  const [isFocus, setIsFocus] = useState(false); // manage internal state of input value.

  const [curValue, setInputValue] = useState(value);
  const {
    langStrings,
    serialNumberAndProductName
  } = state;
  const datalistFiltered = datalist && datalist.filter(item => item.toLowerCase().includes(serialNumberAndProductName.toLowerCase()));
  const inputRef = useRef();
  useEffect(() => {
    if (focusIn) {
      inputRef.current.focus();
    }
  }, [focusIn]); // eslint-disable-next-line no-unused-vars

  const handleFocusChange = e => {
    setIsFocus(true);
  };

  const handleBlurChange = e => {
    setIsFocus(false);
    handleValidation(e.target.value);
  };

  const handleOnChange = e => {
    setInputValue(e.target.value);
    handleChange(e);
  };

  const onKeyDown = e => {
    if (e.key === 'Enter') {
      setIsFocus(false);
      handleValidation(e.target.value);
    }
  };

  return /*#__PURE__*/React.createElement("form", {
    onSubmit: e => {
      handleSubmit();
      e.preventDefault();
    }
  }, /*#__PURE__*/React.createElement(Input, {
    className: className,
    variant: "box",
    placeholder: placeholder,
    onChange: handleOnChange,
    onKeyDown: onKeyDown,
    value: curValue,
    onFocus: e => handleFocusChange(e),
    onBlur: e => handleBlurChange(e),
    inputRef: inputRef,
    id: id,
    autoComplete: autoComplete
  }), datalist && isFocus && /*#__PURE__*/React.createElement(DataList, {
    langStrings: langStrings,
    serialNumberAndProductName: serialNumberAndProductName,
    dispatch: dispatch,
    datalist: datalistFiltered
  }));
};

TextInput.propTypes = {
  state: PropTypes.object,
  dispatch: PropTypes.func,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  handleChange: PropTypes.func,
  handleSubmit: PropTypes.func,
  datalist: PropTypes.array,
  value: PropTypes.string,
  inputRef: PropTypes.object,
  focusIn: PropTypes.bool,
  handleValidation: PropTypes.func,
  isError: PropTypes.bool,
  id: PropTypes.string
};
export default styled(TextInput)`
  margin-bottom: 10px;
  > input {
    font-weight: 400;
    ${({
  isError
}) => isError && `
      border: 1px solid #ec4a41;
      box-shadow: none;
    `}

    :focus {
      ${({
  isError
}) => isError ? `
        border: 1px solid #ec4a41;
        box-shadow: none;
      ` : `border: 1px solid #0696d7;
      box-shadow: 0 0 5px #0696d7;`}

    ::placeholder {
      font-style: italic;
    }
  > div {
    height: 0px;
  }
`;